import React, { useState } from "react";
import AdvisorModal from "./AdvisorModal";
import Slider from "react-slick";
import bajajSmall from '../../../Assets/Images/Insurance/bajaj-small.png';
import generaliCentralSmall from '../../../Assets/Images/Insurance/generali-central-small.png';
import maxLifeSmall from '../../../Assets/Images/Insurance/max-life-small.png';

export default function InsurancePlans() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openAdvisorModal = () => setIsModalOpen(true);
  const closeAdvisorModal = () => setIsModalOpen(false);

  const plans = [
    {
      title: "Generali Central Flexi Term Plan",
      desc: "Affordable cover with flexible options to suit your lifestyle.",
      image: generaliCentralSmall,
    },
    {
      title: "Max Life Smart Term Plan Plus",
      desc: "Smart features, add-ons, and peace of mind at every stage of life.",
      image: maxLifeSmall,
    },
    {
      title: "Bajaj Allianz Smart Protect Goal",
      desc: "Comprehensive protection with critical illness and accidental cover.",
      image: bajajSmall,
    },
  ];

 

const sliderSettings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 500,
  slidesToShow: 1, // desktop default
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024, // tablet max width
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640, // mobile max width
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
  appendDots: (dots) => (
    <div>
      <ul className="tw-flex tw-justify-center tw-space-x-2 tw-mt-4">{dots}</ul>
    </div>
  ),
  customPaging: (i) => (
    <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-gray-300"></div>
  ),
};


  const PlanCard = ({ title, desc, image }) => (
<div className="tw-bg-white tw-rounded-3xl tw-mx-2 tw-p-8 tw-border tw-border-solid tw-border-gray-200 tw-shadow-md lg:hover:tw--translate-y-2 tw-transition-translate-y tw-ease-linear tw-duration-300 ">
      <div className="tw-mb-6">
        <div className="">
          <img src={image} alt="" className="tw-h-[65px] tw-w-[65px] tw-rounded"/>
        </div>
      </div>
      <div className="tw-mb-4">
        <h3 className="tw-text-2xl tw-font-bold tw-text-fintoo-blue tw-pb-0">
          {title}
        </h3>
      </div>
      <div className="tw-space-y-4 tw-mb-6">
        <p className="tw-text-lg tw-text-gray-700">{desc}</p>
      </div>
      <div className="tw-flex tw-space-x-4">
        <button className="tw-flex-1 tw-bg-fintoo-orange tw-text-white tw-py-3 tw-rounded-lg tw-font-medium">
          Know More
        </button>
        <button
          onClick={openAdvisorModal}
          className="tw-flex-1 bg-white tw-border tw-border-solid tw-border-fintoo-blue tw-text-fintoo-blue tw-py-3 tw-rounded-lg tw-font-medium  "
        >
          Talk to Advisor
        </button>
      </div>
    </div>
  );

  return (
    <section id="insurance-plans" className="lg:tw-py-20 tw-py-10 tw-bg-white">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-6">
        {/* Heading */}
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-6">
            Trusted Term Plans, Tailored for You
          </h2>
          <p className="tw-text-lg lg:tw-text-xl tw-text-gray-700">
            Choose from carefully selected plans from India’s leading insurers.
            Whether you want affordability, flexibility, or maximum coverage —
            we help you make the right choice.
          </p>
        </div>

        {/* Mobile Slider */}
        <div className="lg:tw-hidden tw-pb-3">
          <Slider {...sliderSettings}>
            {plans.map((plan, index) => (
                  <div key={index} className="tw-px-2 tw-py-3 lg:tw-py-0"> {/* Horizontal padding adds gap */}

                <PlanCard key={index} title={plan.title} desc={plan.desc}   image={plan.image}/>
                </div>
            ))}
          </Slider>
        </div>

        {/* Desktop Grid */}
        <div className="tw-hidden lg:tw-grid lg:tw-grid-cols-3 tw-gap-8">
          {plans.map((plan, index) => (
            <PlanCard key={index} title={plan.title} desc={plan.desc}  image={plan.image} />
          ))}
        </div>
      </div>

      {isModalOpen && <AdvisorModal onClose={closeAdvisorModal} />}
    </section>
  );
}
